import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Clienti from "./pages/Clienti";
import ClienteDetail from "./pages/ClienteDetail";
import Commesse from "./pages/Commesse";
import Prodotti from "./pages/Prodotti";
import Magazzino from "./pages/Magazzino";
import Reports from "./pages/Reports";
import Utenti from "./pages/Utenti";
import Impostazioni from "./pages/Impostazioni";
import PublicLanding from "./pages/PublicLanding";
import PublicOfferta from "./pages/PublicOfferta";
import AuditLogs from "./pages/AuditLogs";
import ArubaJobs from "./pages/ArubaJobs";
import WhatsappSettings from "./pages/WhatsappSettings";
import AdminErrors from "./pages/AdminErrors";
import MieiCanali from "./pages/MieiCanali";
import Squadre from "./pages/Squadre";
import Calendario from "./pages/Calendario";
import PianificazioneInterventi from "./pages/PianificazioneInterventi";
import Itinerario from "./pages/Itinerario";
import Veicoli from "./pages/Veicoli";
import Analytics from "./pages/Analytics";
import InstallazioniDaPianificare from "./pages/InstallazioniDaPianificare";
import InterventiDaPianificare from "./pages/InterventiDaPianificare";
import Chat from "./pages/Chat";
import MiaAgenda from "./pages/MiaAgenda";
import Progetti3D from "./pages/Progetti3D";
import Progetto3DEditor from "./pages/Progetto3DEditor";

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/public/:token" element={<PublicLanding />} />
            <Route path="/public/offerta/:token" element={<PublicOfferta />} />
            <Route
              element={
                <ProtectedRoute>
                  <Layout />
                </ProtectedRoute>
              }
            >
              <Route path="/" element={<ProtectedRoute menuKey="dashboard"><Dashboard /></ProtectedRoute>} />
              <Route path="/clienti" element={<ProtectedRoute menuKey="clienti"><Clienti /></ProtectedRoute>} />
              <Route path="/clienti/:cid" element={<ProtectedRoute menuKey="clienti"><ClienteDetail /></ProtectedRoute>} />
              <Route path="/commesse" element={<ProtectedRoute menuKey="commesse"><Commesse /></ProtectedRoute>} />
              <Route path="/prodotti" element={<ProtectedRoute menuKey="prodotti"><Prodotti /></ProtectedRoute>} />
              <Route path="/magazzino" element={<ProtectedRoute menuKey="magazzino"><Magazzino /></ProtectedRoute>} />
              <Route path="/calendario" element={<ProtectedRoute menuKey="calendario"><Calendario /></ProtectedRoute>} />
              <Route path="/installazioni-da-pianificare" element={<ProtectedRoute roles={["admin", "operatore"]} menuKey="installazioni_da_pianificare"><InstallazioniDaPianificare /></ProtectedRoute>} />
              <Route path="/interventi-da-pianificare" element={<ProtectedRoute roles={["admin", "operatore", "tecnico"]} menuKey="interventi_da_pianificare"><InterventiDaPianificare /></ProtectedRoute>} />
              <Route path="/progetti-3d" element={<ProtectedRoute roles={["admin", "operatore", "tecnico"]} menuKey="progetti_3d"><Progetti3D /></ProtectedRoute>} />
              <Route path="/progetti-3d/:pid" element={<ProtectedRoute roles={["admin", "operatore", "tecnico"]} menuKey="progetti_3d"><Progetto3DEditor /></ProtectedRoute>} />
              <Route path="/pianificazione-interventi" element={<ProtectedRoute menuKey="pianificazione_interventi"><PianificazioneInterventi /></ProtectedRoute>} />
              <Route path="/itinerario" element={<ProtectedRoute menuKey="itinerario"><Itinerario /></ProtectedRoute>} />
              <Route path="/veicoli" element={<ProtectedRoute roles={["admin", "operatore"]} menuKey="veicoli"><Veicoli /></ProtectedRoute>} />
              <Route path="/reports" element={<ProtectedRoute roles={["admin", "operatore", "magazzino"]} menuKey="reports"><Reports /></ProtectedRoute>} />
              <Route path="/analytics" element={<ProtectedRoute roles={["admin"]} menuKey="analytics"><Analytics /></ProtectedRoute>} />
              <Route path="/utenti" element={<ProtectedRoute roles={["admin"]} menuKey="utenti"><Utenti /></ProtectedRoute>} />
              <Route path="/squadre" element={<ProtectedRoute roles={["admin"]} menuKey="squadre"><Squadre /></ProtectedRoute>} />
              <Route path="/audit-logs" element={<ProtectedRoute roles={["admin"]} menuKey="audit_logs"><AuditLogs /></ProtectedRoute>} />
              <Route path="/aruba-jobs" element={<ProtectedRoute roles={["admin"]} menuKey="aruba_jobs"><ArubaJobs /></ProtectedRoute>} />
              <Route path="/whatsapp-settings" element={<ProtectedRoute roles={["admin"]} menuKey="whatsapp_settings"><WhatsappSettings /></ProtectedRoute>} />
              <Route path="/admin/errors" element={<ProtectedRoute roles={["admin"]} menuKey="admin_errors"><AdminErrors /></ProtectedRoute>} />
              <Route path="/miei-canali" element={<ProtectedRoute menuKey="miei_canali"><MieiCanali /></ProtectedRoute>} />
              <Route path="/mia-agenda" element={<ProtectedRoute roles={["admin", "responsabile", "supervisore"]} menuKey="mia_agenda"><MiaAgenda /></ProtectedRoute>} />
              <Route path="/chat" element={<ProtectedRoute menuKey="chat"><Chat /></ProtectedRoute>} />
              <Route path="/impostazioni" element={<ProtectedRoute roles={["admin"]} menuKey="impostazioni"><Impostazioni /></ProtectedRoute>} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
